import React, { useEffect } from "react";
import { Button } from "@material-ui/core";
import { Header } from "gce-cxinteracts-ui-components-library";
import { useStyles } from "./styles";
import { ConstantMapping } from "../../../Configurations/ConstantsMapping";
import { History } from "history";
import { connect } from "react-redux";
import { ClientModel } from "../../../Models/ReduxModels/ClientDetails";
import UserProfile, {
  UserProfileDetails
} from "../../../Models/ReduxModels/UserProfileModel";
import {
  getClientName,
  getImageDetails,
  redirectToNextRoute
} from "Utils/GeneralUtils";
import {
  logEvents,
  EVENT_TYPE,
  pushAllEventsToServer
} from "Services/EventService";

import { ImagesMapping } from "Configurations/ImagesMapping";

interface IProps {
  history: History;
  clientData: any;
  userProfileData: UserProfileDetails;
}

const SmsPermission: React.FC<IProps> = props => {
  const classes = useStyles();
  const clientName = getClientName();
  const { history, clientData, userProfileData } = props;

  let accessToken = clientData?.token;
  const onLoadParams = {
    page_subsection: "permissions"
  };

  useEffect(() => {
    logEvents({ eventType: EVENT_TYPE.ONBOARDING_SMS_PERMISSION_LANDED });
    pushAllEventsToServer();
  }, []);

  const logNextEvent = permissionOpted => {
    logEvents({ eventType: EVENT_TYPE.NEXT_PAGE_ONBOARDING });
    logEvents({
      eventType: EVENT_TYPE.ONBOARDING_SMS_PERMISSION_EXITED,
      sms: permissionOpted
    });
    pushAllEventsToServer();
  };

  const onClickAllowButton = () => {
    new UserProfile({
      id: "local",
      isFirstUse: userProfileData?.isFirstUse,
      dob: userProfileData?.dob,
      interests: userProfileData?.interests,
      permissions: {
        ...userProfileData?.permissions,
        sms: true
      }
    }).$save();
    logNextEvent(true);
    nextPage();
  };

  const onClickDontAllowLink = () => {
    new UserProfile({
      id: "local",
      isFirstUse: userProfileData?.isFirstUse,
      dob: userProfileData?.dob,
      interests: userProfileData?.interests,
      permissions: {
        ...userProfileData?.permissions,
        sms: false
      }
    }).$save();
    logNextEvent(false);
    nextPage();
  };

  const nextPage = () => {
    const nextRoute = redirectToNextRoute("sms");
    history.push(nextRoute, { onLoadParams });
  };

  return (
    <div className={classes.mainContainer}>
      <Header
        className={classes.header}
        isHeaderInverted={false}
        clientLogoPrimary={getImageDetails(
          ImagesMapping[clientName].clientLogoPrimary,
          ConstantMapping[clientName].CLIENT_ICON_TEXT
        )}
        clientLogoSecondary={getImageDetails(
          ImagesMapping[clientName].clientLogoSecondary,
          ConstantMapping[clientName].CLIENT_ICON_TEXT
        )}
        isScrollHeader={false}
        primaryLogoTabIndex={-1}
        secondaryLogoTabIndex={-1}
      />

      <div className={classes.contentWrapper}>
        <div className={classes.content}>
          <div
            className={classes.imageWrapper}
            style={{ position: "relative" }}
          >
            <div style={{ display: "block" }}>
              <img
                alt="notificationImg"
                src={ImagesMapping[clientName].notificationImg}
                className={classes.notification}
              />
              <img
                alt="smsPermissionHeroImg"
                src={ImagesMapping[clientName].smsPermissionImg}
                className={classes.smsHeroImage}
              />
            </div>
          </div>
          <div className={classes.textWrapper}>
            <h2 className={classes.heading}>
              {ConstantMapping[clientName].SMS_PERMISSION_HEADING}
            </h2>
            <p className={classes.descriptionText}>
              {ConstantMapping[clientName].SMS_PERMISSION_CONTENT}
            </p>
          </div>
          <div className={classes.buttonWrapper}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Button
                variant="contained"
                color="primary"
                className={classes.smsButtonOn}
                onClick={onClickAllowButton}
              >
                {ConstantMapping[clientName].SMS_PERMISSION_BUTTON_TEXT}
              </Button>
              <Button
                className={classes.smsButtonOff}
                onClick={onClickDontAllowLink}
              >
                {ConstantMapping[clientName].SMS_PERMISSION_BOTTOM_LINK}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  let clientData = ClientModel.getInsatnce("", state)?.props;
  let userProfileData = UserProfile.getInsatnce("local", state)?.props;
  return {
    clientData,
    userProfileData
  };
};

export default connect(mapStateToProps)(SmsPermission);
